import RouteParent from 'js/router/route-parent'

import operationalReportIndex from 'js/pages/operational-report/index.js'

export default [
  {
    path: '/operational-report',
    component: RouteParent,
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        name: 'operational-report-index',
        component: operationalReportIndex,
        meta: {
          auth: true

        }
      }
    ]
  }
]
